import nuskin from './namespace.js';
/**
 * nuskin.storage is a faÃ§ade  to abstract away the complexities related storage and cookies.
 *
 * Current goals include life-cycle (e.g. session) and pub-sub event-driven model type functionality.
 *
 * Keys:
 * Rule of thumb on storing keys in nuskin.storage.keys is that if the key is used in several or more places and there
 * isn't a service wrapping it (which would be ideal), and if there is no otherwise appropriate and accessible object to store
 * the keys on, then store it here. What we want to move away from is storing keys as strings entered all over the place.
 * The best practice for strings that need to be used in multiple places is to store them in a constant or variable,
 * which is the function of the nuskin.storage.keys object.
 */
if (!nuskin.storage) {
    (function () {

        // API BEGIN
        function _storage(key, value, options) {
            return init(key, value, options);
        }

        // TODO: This section of code is kept to keep current functionality from breaking.
        // This needs to be removed after other components have been refactored to utilize
        // the modified storage.js
        // Collecting keys here to get a handle on them, partly in order to draw the line between LTO and Market sites.
        // nuskin.storage does not, however, need to be the place to store all cookie/storage keys.  That can be decided on a case-by-case basis.
        _storage.keys = {
            AFTER_LOGIN_URL: "nuskin.account.afterLoginUrl",
            DISPLAY_EMAIL_VERIFY: "nuskin.account.emailVerify",
            AFTER_LOGIN_PARAMS: "nuskin.account.afterLoginParams",
            CAMPAIGNS_VISITED: "nuskin.account.campaignsVisited",
            CART: "cartCookieName",
            CONFIGURATION_OVERRIDE: 'configurationOverride',
            CURRENT_ORDER: "currentOrder",
            DASHBOARD_URL: "nuskin.account.dashboardUrl",
            EVENT_FORM_DATA: "eventFormData",
            FAVORITES_SKU: "favorites-sku",
            FAVORITES_QUICKVIEW: "favoritesQuickview",
            LANDING: "landing",
            LOCAL_ORDER_LIST: "localOrderList",
            LOCAL_ORDER_LIST_NS: "localOrderList-NS",
            LOGGING_OUT: "loggingOut",
            LOGIN_TIMED_OUT: "loginTimedOut",
            NEW_WINDOW_URL: "nuskin.account.newWindowUrl",
            ORDER_LIST: "orderList",
            ROUTER_ALTERNATE_HOME_KEY: "alternateHome",
            ROUTER_CALLBACK_URL: "callbackUrl",
            SHOPPING_CONTEXT: "shoppingContext",
            SPONSOR_ID: "nuskin.account.sponsorId",
            TICKET_COOKIE:"ticketCookie",
            UTM_INFO: "utmInfo"
        };

        const LOCAL_STORAGE = "localStorage",
            SESSION_STORAGE = "sessionStorage",
            COOKIE = "cookie",
            ALL = 'all',
            REQUIRED = 'Required',
            FUNCTIONAL = 'Functional',
            ADVERTISING = 'Advertising';

        /**
         * Stores all cookies, local storage, and session storage metadata such as key, storageType and type
         * storageType values are COOKIE, LOCAL_STORAGE, SESSION_STORAGE
         * type values are FUNCTIONAL, REQUIRED, ADVERTISING
         */
        _storage.metadata = {
            DISPLAY_EMAIL_VERIFY: {
                key: "nuskin.account.emailVerify",
                storageType: LOCAL_STORAGE
            },
            AFTER_LOGIN_URL: {
                key: "nuskin.account.afterLoginUrl",
                storageType: LOCAL_STORAGE
            },
            AFTER_LOGIN_PARAMS: {
                key: "nuskin.account.afterLoginParams",
                storageType: LOCAL_STORAGE
            },
            APP_SETTING_OVERRIDES: {
                key: "appSettingOverrides",
                type: FUNCTIONAL,
                storageType: SESSION_STORAGE
            },
            CAMPAIGNS_VISITED: {
                key: "nuskin.account.campaignsVisited",
                storageType: LOCAL_STORAGE
            },
            CART: {
                key: "cartCookieName",
                type: FUNCTIONAL,
                storageType: COOKIE
            },
            CART_SERVICE: {
                key: "cart",
                type: FUNCTIONAL,
                storageType: LOCAL_STORAGE
            },
            CUSTOM_EVENT_PAYLOAD: {
                key: "cart.customEventPayload",
                storageType: SESSION_STORAGE
            },
            ADR_TYPE: {
                key: "adrType",
                type: REQUIRED,
                storageType: LOCAL_STORAGE
            },
            CURRENT_ORDER: {
                key: "currentOrder",
                type: FUNCTIONAL,
                storageType: LOCAL_STORAGE
            },
            DASHBOARD_URL: {
                key: "nuskin.account.dashboardUrl",
                storageType: LOCAL_STORAGE
            },
            ECOMM3_CART: {
                key: 'shop-cart',
                storageType: LOCAL_STORAGE,
                type: REQUIRED
            },
            EVENT_FORM_DATA: {
                key: "eventFormData",
                type: REQUIRED,
                storageType: LOCAL_STORAGE
            },
            FAVORITES_SKU: {
                key: "favorites-sku",
                type: REQUIRED,
                storageType: SESSION_STORAGE
            },
            FAVORITES_QUICKVIEW: {
                key: "favoritesQuickview",
                type: REQUIRED,
                storageType: SESSION_STORAGE
            },
            LANDING: {
                key: "landing",
                type: REQUIRED,
                storageType: LOCAL_STORAGE
            },
            LOCAL_ORDER_LIST: {
                key: "localOrderList",
                storageType: LOCAL_STORAGE
            },
            LOCAL_ORDER_LIST_NS: {
                key: "localOrderList-NS",
                storageType: LOCAL_STORAGE
            },
            LOGGING_OUT: {
                key: "loggingOut",
                storageType: LOCAL_STORAGE
            },
            LOGIN_TIMED_OUT: {
                key: "loginTimedOut",
                storageType: LOCAL_STORAGE
            },
            LOYALTY_DATA: {
                key: "loyaltyData",
                storageType: LOCAL_STORAGE
            },
            LOYALTY_SHOW_ACCEPT_TC: {
                key: "loyaltyShowAcceptTc",
                storageType: LOCAL_STORAGE
            },
            LOYALTY_SIGNUP_SHOW: {
                key: "loyaltySignupShow",
                storageType: LOCAL_STORAGE
            },
            NEW_WINDOW_URL: {
                key: "nuskin.account.newWindowUrl",
                storageType: LOCAL_STORAGE
            },
            ORDER_LIST: {
                key: "orderList",
                type: FUNCTIONAL,
                storageType: LOCAL_STORAGE
            },
            ROUTER_ALTERNATE_HOME_KEY: {
                key: "alternateHome",
                storageType: LOCAL_STORAGE
            },
            ROUTER_CALLBACK_URL: {
                key: "callbackUrl",
                storageType: LOCAL_STORAGE
            },
            SHOPPING_CONTEXT: {
                key: "shoppingContext",
                storageType: LOCAL_STORAGE
            },
            SPONSOR_ID: {
                key: "nuskin.account.sponsorId",
                storageType: LOCAL_STORAGE
            },
            TICKET_COOKIE: {
                key: "ticketCookie",
                storageType: LOCAL_STORAGE
            },
            USER_COOKIE: {
                key: "nuskin.account.data",
                type: REQUIRED,
                storageType: LOCAL_STORAGE
            },
            USER_COOKIE_BASE: {
                key: "nuskin.account",
                type: REQUIRED,
                storageType: LOCAL_STORAGE
            },
            RUN_CONFIG: {
                key: "run-config",
                type: REQUIRED,
                storageType: SESSION_STORAGE
            },
            NUSKIN_ACCOUNT_DATA: {
                key: "nuskin.account.data",
                type: REQUIRED,
                storageType: LOCAL_STORAGE
            },
            RECEIVING_ITEMS: {
                key: "receiving-items",
                type: REQUIRED,
                storageType: LOCAL_STORAGE
            },
            ORDER_STORAGE_KEY: {
                key: "orders",
                type: REQUIRED,
                storageType: LOCAL_STORAGE
            },
            ORDER_PREFS_STORAGE_KEY: {
                key: "orderPreferences",
                type: REQUIRED,
                storageType: LOCAL_STORAGE
            },
            ORDER_EXTERNALID_KEY: {
                key: "lastOrderExternalID",
                type: REQUIRED,
                storageType: LOCAL_STORAGE
            },
            BUYER_FORM: {
                key: "buyerForm",
                type: REQUIRED,
                storageType: LOCAL_STORAGE
            },
            LTO_VERIFY: {
                key: "lto.verify",
                type: REQUIRED,
                storageType: LOCAL_STORAGE
            },
            WR_KEY: {
                key: "wrkey",
                type: REQUIRED,
                storageType: LOCAL_STORAGE
            },
            CATEGORY_OPTION_NAME_PT: {
                key: 'categoryOptionName_pt',
                type: REQUIRED,
                storageType: COOKIE
            },
            LANGUAGE: {
                key: 'language',
                type: REQUIRED,
                storageType: COOKIE
            },
            GMID: {
                key: 'gmid',
                type: REQUIRED,
                storageType: COOKIE
            },
            HAS_GMID: {
                key: 'hasGmid',
                type: REQUIRED,
                storageType: COOKIE
            },
            EID: {
                key: 'eid',
                type: FUNCTIONAL,
                storageType: COOKIE
            },
            MARKET: {
                key: 'market',
                type: REQUIRED,
                storageType: COOKIE
            },
            J_SESSION_ID: {
                key: 'JSESSIONID',
                type: REQUIRED,
                storageType: COOKIE
            },
            GA: {
                key: '_ga',
                type: ADVERTISING,
                storageType: COOKIE
            },
            GAT: {
                key: '_gat',
                type: ADVERTISING,
                storageType: COOKIE
            },
            GAT_UA_1: {
                key: '_gat_UA-107812110-1',
                type: ADVERTISING,
                storageType: COOKIE
            },
            GAT_UA_2: {
                key: '_gat_UA-107812110-2',
                type: ADVERTISING,
                storageType: COOKIE
            },
            GID: {
                key: '_gid',
                type: ADVERTISING,
                storageType: COOKIE
            },
            NUSKIN_HOME_VISITED: {
                key: 'nuskin.home.visited',
                type: REQUIRED,
                storageType: COOKIE
            },
            NUSKIN_SITE: {
                key: 'nuskin.site',
                type: REQUIRED,
                storageType: COOKIE
            },
            STOREFRONT: {
                key: 'storefront',
                type: REQUIRED,
                storageType: SESSION_STORAGE
            },
            SPONSOR: {
                key: 'sponsor',
                type: REQUIRED,
                storageType: SESSION_STORAGE
            },
            ADR_DRAFT: {
                key: "adr",
                type: REQUIRED,
                storageType: SESSION_STORAGE
            },
            ADR_LIST: {
                key: "adr-list",
                type: REQUIRED,
                storageType: SESSION_STORAGE
            },
            ADR_STATUS: {
                key: "adr-status",
                type: REQUIRED,
                storageType: SESSION_STORAGE
            },
            ADR_DETAIL: {
                key: "adr-detail",
                type: REQUIRED,
                storageType: SESSION_STORAGE
            },
            ADR_CURRENT_ID: {
                key: "adr-id",
                type: REQUIRED,
                storageType: SESSION_STORAGE
            },
            ADR_OVERRIDE_ID: {
                key: "ADROverrideID",
                type: REQUIRED,
                storageType: SESSION_STORAGE
            },
            ADR_ONE_TIME_ITEMS: {
                key: "ADROneTimeItems",
                type: REQUIRED,
                storageType: SESSION_STORAGE
            },
            ADR_REDEEM_PTS_CHECKED: {
                key: "redeem-points-checked",
                type: REQUIRED,
                storageType: SESSION_STORAGE
            },
            ORDER_REASON: {
                key: "orderReason",
                type: REQUIRED,
                storageType: SESSION_STORAGE
            },
            FAVORITES_LIST: {
                key: "favorites-list",
                type: REQUIRED,
                storageType: SESSION_STORAGE
            },
            SITES_LS: {
                key: 'sites',
                type: FUNCTIONAL,
                storageType: LOCAL_STORAGE
            },
            SITES_LSR: {
                key: 'sites',
                type: REQUIRED,
                storageType: LOCAL_STORAGE
            },
            SITES_SS: {
                key: 'sites',
                type: REQUIRED,
                storageType: SESSION_STORAGE
            },
            MEC_JWT: {
                key: 'USER_PROFILE_JWT',
                type: REQUIRED,
                storageType: COOKIE
            },
            MEC_MASTER: {
                key: 'USER_PROFILE_MASTER_INFO',
                type: REQUIRED,
                storageType: COOKIE
            },
            MEC_MIN: {
                key: 'USER_PROFILE_MIN_INFO',
                type: REQUIRED,
                storageType: LOCAL_STORAGE
            },
            LOGGEDIN_KEY: {
                key: 'loggedIn',
                type: REQUIRED,
                storageType: COOKIE
            },
            PERSONAL_OFFER: {
                key: 'personalOffer',
                type: REQUIRED,
                storageType: SESSION_STORAGE
            },
            PERSONAL_OFFER_V2: {
                key: 'personalOffer_v2',
                type: REQUIRED,
                storageType: LOCAL_STORAGE
            },
            PRODUCT_STATUS: {
                key: 'prodStatus',
                type: REQUIRED,
                storageType: SESSION_STORAGE
            },
            SHOW_QUALIFICATIONS_MESSAGE: {
                key: 'availableQualifications',
                type: REQUIRED,
                storageType: SESSION_STORAGE
            },
            VIEWED_QUALIFICATION_MODAL: {
                key: 'viewedQualificationModal',
                type: REQUIRED,
                storageType: LOCAL_STORAGE
            },
            CONFIGURATION_OVERRIDE: {
                storageType: SESSION_STORAGE
            },
            FOOTER_DATA: {
                key: 'footerData',
                type: REQUIRED,
                storageType: SESSION_STORAGE
            },
            MARKET_HEADER_DATA: {
                key: 'marketHeaderData',
                type: REQUIRED,
                storageType: SESSION_STORAGE
            },
            SKINCONSULT: {
                key: 'SKINCONSULT',
                type: REQUIRED,
                storageType: SESSION_STORAGE
            },
            POPULAR_PRODUCTS: {
                key: 'popularProducts',
                type: REQUIRED,
                storageType: SESSION_STORAGE
            },
            PAYMENT_PREF: {
                key: 'paymentPreference',
                type: REQUIRED,
                storageType: SESSION_STORAGE
            },
            SKINCONSULT_VUEX_STATE: {
                key: 'skin-consultation-vuex-state',
                type: REQUIRED,
                storageType: LOCAL_STORAGE
            },
            UTM_INFO: {
                key: 'utmInfo',
                type: REQUIRED,
                storageType: COOKIE
            }
        };

        _storage.setItem = setItem;
        _storage.getItem = getItem;
        _storage.removeItem = removeItem;
        _storage.getAll = getAll;
        _storage.parseResult = parseResult;
        _storage.isAllowed = isAllowed;
        // API END

        /*
         TODO:: clear keys on auth, moving functionality from LocalStorageOrderService.js into storage api
         keys.EVENT_FORM_DATA
         keys.ACCOUNT_DATA
         keys.ADR_EDIT
         keys.ORDER_PREFS_STORAGE_KEY
         */


        //TODO:: Lifecycle and event/model functionality
        //nuskin.storage.clearOnEvent(ORDER_STORAGE_KEY,EVENT_KEY);
        /*
         function loginCheck() {
         var isLoggedIn = nuskin.newAccount.UserService.isLoggedIn();
         if (!isLoggedIn) {
         publicMethods.resetOrderStorage();
         }
         return isLoggedIn;
         }
         */
        // BASE FUNCTIONS

        /**
         * Extracted and modified from:
         *
         * TotalStorage
         * Copyright (c) 2011 Jared Novack & Upstatement (upstatement.com)
         * Dual licensed under the MIT and GPL licenses:
         * http://www.opensource.org/licenses/mit-license.php
         * http://www.gnu.org/licenses/gpl.html
         *
         */

        let ls = localStorage,
            ss = sessionStorage,
            keys = _storage.keys,
            metadata = _storage.metadata,
            items = {};

        /**
         * @param key
         * @param value
         * @returns {*}
         */
        function init(key, value, options) {
            if (typeof value != "undefined") {
                if (options) {
                    return setItem(key, value, options);
                } else {
                    return setItem(key, value);
                }
            } else {
                return getItem(key);
            }
        }

        /**
         * Sets item to cookie/local storage/session storage based on the storageType found
         * on _storage.metadata for that specific storage item.
         * All ls, ss and cookie we use on the site should be added to _storage.metadata
         * @param {Object} metadata // i.e. storage.metadata.CART, storage.metadata.CURRENT_ORDER
         * @param {*} value
         * @param {Object} options // OPTIONAL.  used for storageType cookie
         */
        function setItem(metadata, value, options) {
            let saver;
            if (metadata && isAllowed(metadata.type)) {
                if (metadata.storageType) {
                    switch (metadata.storageType) {
                        case COOKIE:
                            saver = JSON.stringify(value);
                            $.cookie(metadata.key, saver, options);
                            break;
                        case LOCAL_STORAGE:
                            setTtlInItem(value, options);
                            saver = JSON.stringify(value);
                            ls.setItem(metadata.key, saver);
                            break;
                        case SESSION_STORAGE:
                            setTtlInItem(value, options);
                            saver = JSON.stringify(value);

                            ss.setItem(metadata.key, saver);
                            break;
                        default:
                            //console.error("No such storage type"); //TODO Change this to non-console logging
                    }
                } else {
                    // TODO: This section of code is kept to keep current functionality from breaking.
                    // This needs to be removed after other components have been refactored to utilize
                    // the modified storage.js
                    setTtlInItem(value, options);
                    saver = JSON.stringify(value);
                    ls.setItem(metadata, saver);
                }
            } else {
                //console.warn('Storage is denied for ' + metadata.key + '.'); //TODO Change this to non-console logging
            }
            return saver;
        }

        /**
         * Gets item from cookie/local storage/session storage based on the storageType found
         * on _storage.metadata for that specific storage item.
         * All ls, ss and cookie we use on the site should be added to _storage.metadata
         * @param {Object} storage // i.e. storage.metadata.CART, storage.metadata.CURRENT_ORDER
         * @param {Object} options // OPTIONAL.  used for storageType cookie
         */
        function getItem(metadata) {
            if (metadata && isAllowed(metadata.type)) {
                if (metadata.storageType) {
                    switch (metadata.storageType) {
                        case COOKIE:
                            return parseResult($.cookie(metadata.key));
                        case LOCAL_STORAGE:
                            return getLsItemTtl(metadata.key);
                        case SESSION_STORAGE:
                            return getSsItemTtl(metadata);
                        default:
                            //console.error("No such storage type"); //TODO needs to go to an error log
                            return;
                    }
                } else {
                    // TODO: This section of code is kept to keep current functionality from breaking.
                    // This needs to be removed after other components have been refactored to utilize
                    // the modified storage.js
                    return getLsItemTtl(metadata);
                }
            } else {
                //console.warn(metadata.key + ' cannot be found because it has been denied.'); //TODO Change this to non-console logging
            }
        }

        /**
         * Removes cookie, local storage, or session storage item.
         * @param {*} metadata
         * @param {*} options // for cookie
         */
        function removeItem(metadata, options) {
            if (metadata && metadata.storageType) {
                switch (metadata.storageType) {
                    case COOKIE:
                        return $.removeCookie(metadata.key, options);
                    case LOCAL_STORAGE:
                        return ls.removeItem(metadata.key);
                    case SESSION_STORAGE:
                        return ss.removeItem(metadata.key);
                    default:
                        //console.error("No such storage type"); //TODO needs to go to an error log
                }
            } else {
                // TODO: This section of code is kept to keep current functionality from breaking.
                // This needs to be removed after other components have been refactored to utilize
                // the modified storage.js
                return ls.removeItem(metadata);
            }
        }

        // WARNING: This getAll function is not updated and we're looking into
        // possibly deprecating this.
        function getAll(storageType) {
            const items = [];
            for (const i in ls) {
                if (i.length) {
                    items.push({key: i, value: getItem(i)});
                }
            }
            return items;
        }

        /**
         * Parses the response for getItem
         * @param {*} res
         */
        function parseResult(res) {
            let ret;

            try {
                ret = JSON.parse(res);
                // if (ret === "true") {
                //     ret = true;
                // }
                // if (ret === "false") {
                //     ret = false;
                // }
                // if (ret === "null") {
                //     ret = null;
                // }
                // if (parseFloat(ret) == ret) {
                //     ret = parseFloat(ret);
                // }
            } catch (e) {
                ret = res;
            }

            return ret;
        }

        /**
         * Checks Trust Arc API to see if storage type is allowed or denied.
         * @param {*} type //i.e. Required, Functional, Advertising
         */
        function isAllowed(type) {
            const trustArcLs = parseResult(ls.getItem("truste.eu.cookie.notice_gdpr_prefs"));
            if (trustArcLs) {
                if (type) {
                    const allowedStorageArray = trustArcLs.value.replace(/\:$/, '').split(',');
                    const typeInTrustArcValue = convertTypeToTrustArcValue(type);
                    return allowedStorageArray.includes(typeInTrustArcValue);
                } else {
                    return true; // TODO: Used for backwards compatibility.  Remove after everything has been refactored to use the new storage.js
                }
            }
            return !trustArcLs;
        }

        function setTtlInItem(item, options) {
            if (options && options.ttl) {
                if (parseInt(options.ttl) != options.ttl) {
                    //console.error('Bad TTL value for localStorage item'); //TODO this needs to go to error logging
                } else {
                    item.ttl = Date.now() + parseInt(options.ttl);
                }
            }
        }

        function convertTypeToTrustArcValue(type) {
            switch (type) {
                case REQUIRED:
                    return "0";
                case FUNCTIONAL:
                    return "1";
                case ADVERTISING:
                    return "2";
            }
        }

        function getLsItemTtl(key) {
            let result = parseResult(ls.getItem(key));

            if (result && result.ttl !== null && result.ttl < Date.now()) {
                removeItem(key);
                result = null;
            }
            return result;
        }

        function getSsItemTtl(metadata) {
            let result = parseResult(ss.getItem(metadata.key));

            if (result && result.ttl !== null && result.ttl < Date.now()) {
                removeItem(metadata);
                result = null;
            }
            return result;
        }

        /**
         * Removes storage entries with an expired TTL
         */
        function cleanUpStorageTtl() {
            Object.keys(ls).forEach(key => {
                // removes item if expired
                getLsItemTtl(key);
            });
            Object.keys(ss).forEach(key => {
                // removes item if expired
                getSsItemTtl({key: key, storageType: SESSION_STORAGE});
            });
        }

        // END TOTAL STORAGE FUNCTIONS

        // OTHER BASE FUNCTIONS

        cleanUpStorageTtl();
        nuskin.storage = _storage;

        //TEST FUNCTIONS
        // testStorage();

        /*
        function testStorage() {
            metadata.TEST_COOKIE = {
                key: "testCookie",
                type: REQUIRED,
                storageType: COOKIE
            }
            metadata.TEST_LOCAL_STORAGE = {
                key: "testLocalStorage",
                type: FUNCTIONAL,
                storageType: LOCAL_STORAGE
            }
            metadata.TEST_SESSION_STORAGE = {
                key: "testSessionStorage",
                type: ADVERTISING,
                storageType: SESSION_STORAGE
            }
            _storage.setItem(metadata.TEST_COOKIE, {test: "testCookie"}, {maxAge: 30000});
            _storage.setItem(metadata.TEST_LOCAL_STORAGE, {value: "testLocalStorage"}, {ttl: 10000});
            _storage.setItem(metadata.TEST_SESSION_STORAGE, "testSessionStorage");
            var cookieData = _storage.getItem(metadata.TEST_COOKIE);
            var localStorageData = _storage.getItem(metadata.TEST_LOCAL_STORAGE);
            var sessionStorageData = _storage.getItem(metadata.TEST_SESSION_STORAGE);
            console.info('cookieData is ... ', cookieData);
            console.info('localStorageData is ... ', localStorageData);
            console.info('sessionStorageData is ... ', sessionStorageData);
            setTimeout(function () {
                let newLocalStorage = _storage.getItem(metadata.TEST_LOCAL_STORAGE);
                console.info('localStorageData is after ttl expires ... ', newLocalStorage);
            }, 15000);

            let cookie = _storage(metadata.TEST_COOKIE, {test: "testCookie"}, {maxAge: 30000});
            console.log('cookie: ', cookie);
        }
        */
    })();
}

export default nuskin.storage;
